<template>
    <main>
        <!-- breadcrumb area start here -->
        <section class="bd-breadcrumb-area p-relative fix theme-bg">
            <!-- breadcrumb background image -->
            <div class="bd-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/bg/breadcrumb-bg.jpg)' }"></div>
            <div class="bd-breadcrumb-wrapper mb-60 p-relative">
                <div class="container">
                    <div class="bd-breadcrumb-shape d-none d-sm-block p-relative">
                        <div class="bd-breadcrumb-shape-1">
                        </div>
                        <div class="bd-breadcrumb-shape-2">
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-xl-10">
                            <div class="bd-breadcrumb d-flex align-items-center justify-content-center">
                                <div class="bd-breadcrumb-content text-center">
                                    <h1 class="bd-breadcrumb-title">Scholarship Details</h1>
                                    <div class="bd-breadcrumb-list">
                                        <span><a href="/"><i class="flaticon-hut"></i>Home</a></span>
                                        <div class="bd-breadcrumb-list">
                                            <span><a href="#">Admission</a></span>
                                        </div>
                                        <span>Scholarship Details</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd-wave-wrapper bd-wave-wrapper-3">
                <div class="bd-wave bd-wave-3"></div>
                <div class="bd-wave bd-wave-3"></div>
            </div>
        </section>
        <!-- breadcrumb area end here  -->

        <!-- program routine area start here  -->
        <section class="bd-routine-area pb-70 mt-100">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="bd-section-title-wrapper text-center mb-55 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".2s">
                            <h2 class="bd-section-title mb-0">Baburam Vedanta Public School <br /> Scholarship
                                Opportunities</h2>
                            <p>Empowering Students through Need-Based and Merit Cum Scholarships</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="bd-routine-table mb-50 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col" style="width: 80%;">Scholarship</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Concession in Fees 3rd Child of a family 50% (Only if paid one time)</td>
                                        <td>50%</td>
                                    </tr>
                                    <tr>
                                        <td>Concession in Fees 4th Child of a family 100% (Only if paid one time)</td>
                                        <td>100%</td>
                                    </tr>
                                    <tr>
                                        <td>Concession in Fees (Défense- Martyr)-Rebate 100%</td>
                                        <td>100%</td>
                                    </tr>
                                    <tr>
                                        <td>Concession in Fees (Défense-Service)-Rebate 50%</td>
                                        <td>100%</td>
                                    </tr>
                                    <tr>
                                        <td>Orphan Student</td>
                                        <td>100%</td>
                                    </tr>

                                    <tr>
                                        <td>Single parent - Students</td>
                                        <td>50%</td>
                                    </tr>
                                    <tr>
                                        <td>Merit Students : Marks - 75% to 85%</td>
                                        <td>25%</td>
                                    </tr>
                                    <tr>
                                        <td>Merit Students : Marks - 86% to 90%</td>
                                        <td>50%</td>
                                    </tr>
                                    <tr>
                                        <td>Merit Students : Marks - 91% to 95%</td>
                                        <td>75%</td>
                                    </tr>
                                    <tr>
                                        <td>Merit Students : Marks - 96% to 100%</td>
                                        <td>100%</td>
                                    </tr>
                                    <tr>
                                        <td>National Sports Player</td>
                                        <td>75%</td>
                                    </tr>
                                    <tr>
                                        <td>State Sports Player</td>
                                        <td>50%</td>
                                    </tr>

                                    <tr>
                                        <td>Management Quota 100% Donors & Journalists</td>
                                        <td>100%</td>
                                    </tr>
                                    <tr>
                                        <td>Management Quota 50% Facilitators</td>
                                        <td>50%</td>
                                    </tr>
                                    <tr>
                                        <td>Staff Students</td>
                                        <td>100%</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <!-- <div class="col-lg-4">
                     <div class="bd-program-details-slider p-relative wow fadeInRight" data-wow-duration="1s" data-wow-delay=".3s" style="visibility: visible; animation-duration: 1s; animation-delay: 0.3s; animation-name: fadeInRight;">
                        <div class="bd-program-details-slider-thumb p-relative">
                           <img src="assets/img/program/details-1.jpg" alt="img not found!">
                           <div class="panel-2 wow" style="visibility: visible; animation-name: panel;"></div>
                        </div>
                     </div>
                  </div> -->
                </div>
                <div class="row">
                    *Disclaimer: The school reserves the right to deny or modify scholarships at its discretion based
                    on eligibility criteria and evaluation processes.
                </div>
            </div>
        </section>
        <!-- program routine area end here  -->

    </main>
</template>
<script>
export default {
    name: "ScholarshipView",
};
</script>
